import React from "react";

import { IconButton, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  ticketHeader: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.type === "dark" ? "#263247" : "#e7edf5"}`,
    flex: "none",
    minHeight: 72,
    minWidth: 0,
    padding: theme.spacing(0.75, 1),
    [theme.breakpoints.down("sm")]: {
      flexWrap: "nowrap",
      minHeight: 64,
      overflowX: "auto",
      overflowY: "hidden",
      WebkitOverflowScrolling: "touch",
    },
  },
  backButton: {
    color: theme.palette.type === "dark" ? "#cbd5e1" : "#536176",
    flexShrink: 0,
    marginRight: theme.spacing(0.5),
  },
}));

const TicketHeader = ({ loading, children }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleBack = () => {
    history.push("/tickets");
  };

  return (
    <>
      {loading ? (
        <TicketHeaderSkeleton />
      ) : (
        <Paper square elevation={0} className={classes.ticketHeader}>
          <IconButton
            aria-label="Volver a la bandeja"
            className={classes.backButton}
            onClick={handleBack}
            size="small"
          >
            <ArrowBackIos />
          </IconButton>
          {children}
        </Paper>
      )}
    </>
  );
};

export default TicketHeader;
